import React, { useState } from 'react'
import PropTypes from 'prop-types'
import colors from '../../../configuration/colors'
import Modal from '../../mini/Modal'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import { Diamond } from '../../Mentor/Shared/FocusSkills/styles'
import Checkbox from '../../mini/Checkbox'
import { P2, Caption4 } from '../../styled/typography/typography'
import { Alert, AlertWrapper, CancelButton, Header } from './_Styled'
import FrameworkSkill from '../../mini/Skills/FrameworkSkill'
import useLexicon from '../../../hooks/useLexicon'
import { useTheme } from 'styled-components'

const DeleteFocusSkill = ({ frameworkSkillId, onCancel, onDelete }) => {
  const lexicon = useLexicon()
  const theme = useTheme()
  const [applyToAllSections, setApplyToAllSections] = useState(true)

  return (
    <Modal width={500} top={50} autoHeight allowOverflow>
      <Alert>
        <AlertWrapper>
          <div
            style={{
              padding: '30px'
            }}
          >
            <FlexAlignCenter style={{ justifyContent: 'center' }}>
              <FrameworkSkill frameworkSkillId={frameworkSkillId} />
            </FlexAlignCenter>
            <Header as="h3">
              Are you sure you want to clear this {lexicon.focus_skill} from
              this {lexicon.activity}?
            </Header>
            <P2 as="p">
              Your guidance text will be saved in case you choose to identify
              this {lexicon.skill.toLowerCase()} within this{' '}
              {lexicon.activity.toLowerCase()} again.
            </P2>
          </div>
          <FlexAlignCenter
            style={{
              justifyContent: 'space-between',
              width: '100%',
              padding: '20px',
              borderTop: `1px solid ${colors.rock}`
            }}
          >
            <FlexAlignCenter>
              <Checkbox
                checked={applyToAllSections}
                onChange={e => {
                  setApplyToAllSections(e.target.checked)
                }}
              />
              <Caption4 as="caption">
                Remove from all my {lexicon.section.toLowerCase()}s
              </Caption4>
            </FlexAlignCenter>

            <FlexAlignCenter style={{ justifyContent: 'flex-end' }}>
              <CancelButton className="quest-btn btn-c" onClick={onCancel}>
                Cancel
              </CancelButton>
              <button
                className={`quest-btn btn-a btn-a-${theme?.style}`}
                style={{
                  marginLeft: '10px',
                  paddingLeft: '40px',
                  paddingRight: '40px'
                }}
                onClick={() => {
                  onDelete(applyToAllSections)
                }}
              >
                Remove
              </button>
            </FlexAlignCenter>
          </FlexAlignCenter>
        </AlertWrapper>
      </Alert>
    </Modal>
  )
}

DeleteFocusSkill.propTypes = {
  frameworkSkillId: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default DeleteFocusSkill
